var cadence = {       
  slider: function(){
    $('.ctsd_slider').slick({
      speed: 8000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      infinite: true,
      variableWidth: true,      
      slidesToScroll: 1,
      arrows: false,
      dots: false, 
    });
  

    /*  
     $('.icon_slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,         
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed:3500,
        arrows: false,
        dots: false,
        cssEase: 'linear'
      });
    */   
    $('.tkdt_slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,  
        autoplay: true, 
        speed: 800,
        autoplaySpeed: 2500, 
        fade: true,
         cssEase: 'linear',
        arrows: false,
        dots: false, 
    });
    
    $('.thimg_slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,  
        autoplay: false, 
        speed: 1500,
      
        arrows: true,
        dots: false, 
        responsive: [
            {
              breakpoint: 1025,
              settings: {
                 slidesToShow: 2
              }
            },
            {
              breakpoint: 680,
              settings: {
                 slidesToShow: 1
              }
            }
        ]
    });
    

     var home_video =   $('.hmvd_slider');
    home_video.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,  
        autoplay: true,
        autoplaySpeed: 10000, 
        speed: 1500,
        arrows: false,
        dots: true,
        adaptiveHeight: true,
        cssEase: 'linear',
        fade:true,
        focusOnSelect: false,
        pauseOnHover:false,
        responsive: [
            {
              breakpoint: 1025,
              settings: {
                 autoplaySpeed: 10000, 
                 speed: 1500
              }
            }
           ]
    });

    
    var v = $('.hmvd_slider .slick-active .mobile_hide video').html(); 
     if(typeof v !== 'undefined'){
       $('.hmvd_slider .slick-active .mobile_hide video').get(0).play(); 
     }
    /*
     var v2 = $('.hmvd_slider .slick-active .mobile_show video').html(); 
     if(typeof v !== 'undefined'){
       $('.hmvd_slider .slick-active .mobile_show video').get(0).play(); 
     }
     */
    
    home_video.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      setTimeout(function(){ 
         
            var w_size = $(window).width();
           if(w_size > 1024){
              var video = $('.hmvd_slider .slick-active .mobile_hide video').html();  
             if(typeof video !== 'undefined'){
                 $('.hmvd_slider .slick-active .mobile_hide video').get(0).play();
              }
           }else{
             /*
             var video = $('.hmvd_slider .slick-active .mobile_show video').html();  
             if(typeof video !== 'undefined'){
                 $('.hmvd_slider .slick-active .mobile_show video').get(0).play();
              }
              */
           }
            
         }, 1100);
   });

    var yrsd = $('.yrsd_slider');
    var item = $(".yrsd_slider .yrsd_item").length;
    yrsd.slick({
        infinite: false, 
        slidesToShow: 8.1,
        autoplay: false, 
        arrows: false,
        dots: false,
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 7.1
              }
            },
            {
              breakpoint: 1120,
              settings: {
                slidesToShow: 6.1
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5.1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 4.2
              }
            },
            {
              breakpoint: 680,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 520,
              settings: {
                slidesToShow: 2.1
              }
            }     
          ]
      });
    $('.yrsd_prev').on('click', function(){
       yrsd.slick('slickPrev');
    });
    $('.yrsd_next').on('click', function(){
       yrsd.slick('slickNext');
    });
     yrsd.on('afterChange', function (event, slick, currentSlide) { 
       
        if(currentSlide === 2) {
            $('.yrsd_next').removeClass('active');
        }
        else {
            $('.yrsd_next').addClass('active');
        }

        if(currentSlide === 0) {
            $('.yrsd_prev').removeClass('active');
        }
        else {
            $('.yrsd_prev').addClass('active');
        }  
    })

     var video_slider = $('.cmty_flx');
        video_slider.slick({
          infinite: false,
          slidesToShow: 5,
          slidesToScroll:2,
          speed:300,
          arrows: false,
          dots: false,
          responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2
              }
            }  
          ]
      });

    $('.cmty_left').on('click', function(){
       video_slider.slick('slickPrev');
    });
    $('.cmty_right').on('click', function(){
       video_slider.slick('slickNext');
    });



    $('.tmsd_slider').slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll:1,  
          speed:300,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 3 
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2 
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1
              }
            }  
          ]
      });
     
  },
  all_option: function(){ 

    $('.more_item').on('click', function(){
       $('.thumbnail-slider').addClass('active');
    });

     tab_slider();

     function tab_slider(){
        if ($('.podtbfqsd__slider').hasClass('slick-initialized')) {
            $('.podtbfqsd__slider').slick('unslick');
        }
        
        $('.podtbfqsd__slider').slick({
              infinite: true,
              slidesToShow: 1,  
              speed:300,
              arrows: false,
              dots: true,
        });
     }



    $('.pdvds_play').on('click', function(){
      var video = $(this).closest('.pdvds_play_video').prev('video').get(0);
      if(video.paused){
          video.play();
          $(this).text('Pause Video');
      }else{
          video.pause();
          $(this).text('Play Video');
      }
    });

    $('.podtbfq_list').on('click', function(){
       var id = $(this).data('id');
       $('.podtbfq_list, .podtbfq_accoudin, .podtbfqsd__image_listing').removeClass('active');
       $(this).addClass('active');
       $('.podtbfq_accoudin[data-id="'+id+'"], .podtbfqsd__image_listing[data-id="'+id+'"]').addClass('active');

       tab_slider();
    });

    setTimeout(function(){
      $('.product_earlypregnancytest .reputon-count-number').html('4.8').show();
      var d = $('.product_earlypregnancytest .reputon-count-text svg:first-child path').attr('d');
      $('.product_earlypregnancytest .reputon-count-text svg:last-child path').attr('d', d);
      $('.product_earlypregnancytest .reputon-rating-stars svg:last-child path').attr('d', d);
    }, 1500);
    setTimeout(function(){
      $('.product_earlypregnancytest .reputon-count-number').html('4.8').show();
      var d = $('.product_earlypregnancytest .reputon-count-text svg:first-child path').attr('d');
      $('.product_earlypregnancytest .reputon-count-text svg:last-child path').attr('d', d);
      $('.product_earlypregnancytest .reputon-rating-stars svg:last-child path').attr('d', d);
    }, 3500);

    $('.gtwb_bg, .gtwb_close').on('click', function(){
       $('.gtwb_popup').hide();
     });
    $('.gtfm_big_Txt').on('click', function(){
       $('.gtwb_popup').show();
     });

       

      $('.tbstbtn_link').on('click', function(){
        var id = $(this).data('id');
       $('.tbstbtn_link, .tbstbtn_detail').removeClass('active');
       $(this).addClass('active');
       $('.tbstbtn_detail[data-id="'+id+'"]').addClass('active');
      
    });

    $('.tmsd_item_video video').on('mouseover', function(e){
      hoverVideo(e);
    }).on('mouseout', function(e){
      hideVideo(e);
    })
    
      function hoverVideo(e) {
        e.target.play();
      }
      
      function hideVideo(e) {
         e.target.pause();
      }

     $('.tbstdpd_value').on('click', function(){
        if(!$(this).hasClass('active')){
          $('.tbstdpd_value').removeClass('active');
          $('.tbstdpd_list').hide();
        }
         $(this).toggleClass('active');
         $(this).next('.tbstdpd_list').slideToggle();
     });
     $('.tbstdpd_opton').on('click', function(){
         var that = $(this);
         var id = that.data('id');
       
         $('.tbst_drowpdown .tbstdpd_item').each(function(){
           var txt = $(this).find('.tbstdpd_value').data('text');
           $(this).find('.tbstdpd_value').html(txt);
         });
          
        /*
        var html = that.data('text');
        var heading = that.data('heading');
        var url = that.data('url'); 
        $('.lbbx_btn').attr('href', url);
       */

        that.closest('.tbstdpd_list').slideToggle();     
        that.closest('.tbstdpd_list').prev('.tbstdpd_value').html(id);


        // data
        
        var current_time = strToDate(that.closest('.tbstdpd_list').prev('.tbstdpd_value').data('time'));
        var select_time = strToDate(that.data('time'));
        
       console.log(current_time);
       console.log(select_time);
        var diff = parseInt(Math.abs(current_time.getTime() - select_time.getTime()) / 3600000);
        console.log(diff);

       var content= "It looks like you’ve missed the 72 hour window to take Morning After Pill. Please contact your current healthcare provider as soon as possible";
       if(diff < 72){
           diff = 72 - diff;
           content = 'You have <span class="hur_txt">'+diff+' hours</span>  left to take Morning After Pill, but try to take it as soon as possible.'
                       + 'Find stores near you that carry Morning After Pill by using our store finder.'
       } 
       $('.lbbx_description p').html(content);
        
        $('.lbbx_box').show();
     });

     function strToDate(dtStr) {
      if (!dtStr) return null
      let dateParts = dtStr.split("/");
      let timeParts = dateParts[2].split(" ")[1].split(":");
      dateParts[2] = dateParts[2].split(" ")[0];
      // month is 0-based, that's why we need dataParts[1] - 1
      return dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1]);
    }

    $('.qty_value').on('click', function(){
       $(this).toggleClass('active');
       $('.qty_ul').slideToggle(100);
    });
    $('.qty_li').on('click', function(){
      $('.qty_ul').slideToggle(100);
      $('.qty_value').toggleClass('active');
      var id = parseInt($(this).data('id'));
      var html = $(this).data('text');
      var title = $(this).data('title');
      $('.qty_value').html(html);
      

      // $('.product-form__input .select__select').val(title).change();

      var sortBySelect = document.querySelector(".product-form__input select.select__select"); 
      sortBySelect.value = title; 
      sortBySelect.dispatchEvent(new Event("change"));
      
       /*
       $('.product-form__input .select__select').change(); 
       let element = document.getElementById("Option-template--19863655022881__main-0");
      let changeEvent = new Event('change');
      element.dispatchEvent(changeEvent);
      */
    });
    

    $('.fqlst_txt').on('click', function(){

      if(!$(this).hasClass('active')){
         $('.fqlst_txt.active').next('.fqlst_detail').slideToggle();
         $('.fqlst_txt').removeClass('active');
      } 

        var id = $(this).data('id');
        $(this).toggleClass('active');
        $('.fqlst_detail[data-id="'+id+'"]').slideToggle();
    });

    $('.quantity__input').on('change', function(){
      if($(this).hasClass('active')){
        var price = (parseInt($(this).data('price'))/100).toFixed(2);
        var saleprice = (parseInt($(this).data('saleprice'))/100).toFixed(2);
        var qty = parseInt($(this).val());
        var price_normal = price;


        if(saleprice == 'NaN'){
          //console.log('gaura');          
          price = ((price )*qty).toFixed(2);
          //console.log(price);
          $('.price_box .price-item--regular').html('$'+price); 
        }else{ 
         
        if(qty > 1){
           price = ((price - price )*qty).toFixed(2);
           saleprice = ((saleprice - saleprice*15/100)*qty).toFixed(2);
           price_normal = (price_normal*qty).toFixed(2);
           $('.price_box .qty_price').html('$'+price_normal); 
        }else{
           $('.price_box .qty_price').html(''); 
        }
         
          $('.price_box .price-item--sale').html('$'+price);
          $('.price_box .price-item--regular').html('$'+saleprice); 
       }
      }
    });

     $('[name="quantity"]').on('change paste keyup', function(){
        var qty = $(this).val();
        var url = $('.direct_checkout').data('url');
        url = url+qty;
        $('.direct_checkout').attr('href', url);  


        //
        var url = $('.direct_checkout_spanish').data('url');
        url = url+qty;
        $('.direct_checkout_spanish').attr('href', url);  
    });
    
  },
 map: function(){     
                 var Lat = 37.804363, Lng =  -122.271111, result = 0, ip_address = 0, address='', g_addresds='', show_map = true, block_id = true;
     
                 var getPosition = {
                    enableHighAccuracy: false,
                    timeout: 5000,
                    maximumAge: 0
                  }; 
              
     
                  function error(err) {
                      
                    show_form();
                    show_map = false;
                    block_id = false;
                    console.warn(`ERROR(${err.code}): ${err.message}`);
                  };
                    
                  navigator.geolocation.getCurrentPosition(success, error, getPosition);
                  //show_form();
 
     
               function success(gotPosition) { 
                    console.log('success');
                    Lat = gotPosition.coords.latitude;
                    Lng = gotPosition.coords.longitude;
                    show_map = false;
                   show_form();

                  loadtime_upload(Lat, Lng);
                  

                  // gtm 4
                  window.dataLayer.push({'event': 'location_permission_allowed'});
               }

             setTimeout(function(){ 
                if(show_map){
                  show_form();
                }
             }, 25900);


        function loadtime_upload(Lat, Lng){

            setTimeout(function(){ 
              /*
               $.ajax({
                        url: "https://geolocation-db.com/jsonp",
                        jsonpCallback: "callback",
                        dataType: "jsonp",
                        success: function(location) { 
                         address = location.city+','+location.state+','+location.country_name
                         ip_address = location.IPv4;
                          g_addresds = location.city+' '+location.state+' '+location.country_name
                        }
                  });
                */
                  
                  //get zipcode
                  var Gurl = 'https://maps.googleapis.com/maps/api/geocode/json?latlng='+Lat+','+Lng+'&key=AIzaSyAJskdmjg9sum6tfocsi4ejijiAcNL-Qog';
                  $.ajax({url: Gurl, success: function(show){  
                     var size= show.results[0]['address_components'].length; 
                      var zip = show.results[0]['address_components'][size-1].short_name;
                      address = show.plus_code.compound_code;
                      //g_addresds = show.plus_code.compound_code;
                      g_addresds = show.plus_code.compound_code.replace(/^[A-Z0-9+]+\s/, '');
                     $(show.results).each(function(index, item){ 
                        $(item['address_components']).each(function(count, list){
                             
                             if(list.types[0] == 'postal_code' && list.long_name.length > 4){
                               zip = list.long_name; 
                             }
                        });
                     }); 
                     


                    // add value in google sheet

                    /*
                    console.log(block_id);
                     if(!block_id){
                       ip_address ='';
                       Lat = '';
                       Lng = '';
                       address = '';
                       g_addresds = '';
                   }
                    */
                    save_value(zip, address);
                    
                     var date = new Date();
                     $('.ggsf_zipcode').val(zip);
                     $('.ggsf_ipaddress').val(ip_address);
                     $('.ggsf_latitude').val(Lat);
                     $('.ggsf_longitude').val(Lng);
                     $('.ggsf_address').val(address);
                     $('.ggsf_result').val(''); 
                     $('.ggsf_date').val(date); 
                     $('.ggsf_type').val('Allowed');
        
                  
                  const scriptURL = 'https://script.google.com/macros/s/AKfycbxOtCfgNKFv9zh8f29-9iHq4buHh6vQ7ujZH7YVNiJjwnaQDNZwj4am_4mgCnHHtu8u/exec'
                  const form = document.forms['contact-form']
                   
                    fetch(scriptURL, { method: 'POST', body: new FormData(form)})
                    .then(response => console.log("Thank you! your form is submitted successfully." )) 
                    .catch(error => console.error('Error!', error.message))

                    
                    
                  }});

              }, 550); 
           }

            // save value
                 function save_value(zip, address){    

                  console.log(address);
                   console.log(g_addresds);

                    var get_current_url = window.location.href;  
                    var url = 'https://beeveeapps.co/cadence/index.php?&latitude='+Lat+'&longitude='+Lng+'&zipcode='+zip+'&address='+g_addresds+'&type=Allowed&url='+ encodeURIComponent(get_current_url);
                   // var url = 'http://35.235.108.255/index.php?&latitude='+Lat+'&longitude='+Lng+'&zipcode='+zip+'&address='+g_addresds+'&type=Allowed';
                   $.ajax({url: url, success: function(show){
                       console.log(show);
                    }});
                    
                    
                    // google 
                     var url_g = 'https://zipcodedb.cadenceotc.com/index.php?&latitude='+Lat+'&longitude='+Lng+'&zipcode='+zip+'&address='+g_addresds+'&type=Allowed&url='+ encodeURIComponent(get_current_url);
                     $.ajax({url: url_g, success: function(show){
                       console.log(show);
                    }}); 
                 }

                 var storeLocator = $('#bh-sl-map-container');
                  var stor_file = "https:\/\/cdn.shopify.com\/s\/files\/1\/0787\/9734\/0961\/files\/all_store_14_10_2026.json?v=1791953491";
                  var type_url = 'Searched';
                  if($('.mpst_zipcode_input').hasClass('active')){
                      var stor_file = "https:\/\/cdn.shopify.com\/s\/files\/1\/0787\/9734\/0961\/files\/uti_13.10.2026.json?v=1791878969";
                      type_url = 'Searched-UTI';
                  }

            
            function show_form(){
               
                var markers = $('.markers').html();
				 storeLocator.storeLocator({
                  'maxDistance': true,
                  'slideMap': false,
                  'fullMapStart': false,
                  'lengthUnit': 'miles',
                  'defaultLat' : Lat,
                  'defaultLng' : Lng,
                  'defaultLoc': true,
                  'distanceAlert': -1,
                  'dataLocation': stor_file, 
                  'dataType': 'json', 
                  'regionID': 'AU',
                  'zoom' : 16, 
                  'storeLimit': 30, 
                  'fullMapStartBlank' :false,                  
                  'autoGeocode': false, 
                  'noResultsDesc': 'We’re not currently in your area, but we’re on our way! <a class="button_map" href="https://cadenceotc.com/products/morning-after-pill">Be prepared. Buy Online</a><a class="normal_link" href="https://cadenceotc.com/pages/form-map">REQUEST CADENCE OTC IN YOUR AREA</a>',
                  // 'listTemplatePath': 'https://beeveeapps.co/cadence/storeLocator/location-list-description.html',
                 //'infowindowTemplatePath' :'https://beeveeapps.co/cadence/storeLocator/infowindow-description.html' ,
                'listTemplatePath': '//cadenceotc.com/cdn/shop/t/110/assets/location-list-description.html?v=93937726109870553541775819656',
                'infowindowTemplatePath': '//cadenceotc.com/cdn/shop/t/110/assets/infowindow-description.html?v=164911315463267821211775819650',
                  'markerImg': "\/\/cadenceotc.com\/cdn\/shop\/t\/110\/assets\/map_1.png?v=137177210360946047391775819659",
                  'markerDim': {
                      height: 40,
                      width: 40
                    }
                });
 
              //  dataLocation: 'https://cdn.shopify.com/s/files/1/0086/9128/6076/files/locations.json', 'dataType': 'json',  'dataRaw': markers,  
             //'dataType': 'xml',  'dataRaw': markers,  
             //https://cadenceotc.com/cdn/shop/t/21/assets/locations.json
            // 'dataLocation': "\/\/cadenceotc.com\/cdn\/shop\/t\/110\/assets\/locations.json?v=172653449555831947661775819657", 
            //  "https:\/\/cdn.shopify.com\/s\/files\/1\/0787\/9734\/0961\/files\/all_store_14_10_2026.json?v=1791953491", 
     
          }
   

        $('form.location_address_first').on('submit', function(e){
          e.preventDefault();
          var id = $('.mpst__input').val();
          $('[name="bh-sl-address"]').val(id);
          $('form#bh-sl-user-location').submit();
          setTimeout(function(){
              $('.mpst_zipcode').hide();
              $('.clkup_form').show();
              $('#bh-sl-address').focus();
              $('.mpst_inner').addClass('active');
              
          }, 300);
          
        });
 
      $('body').on('submit', 'form#bh-sl-user-location', function(){
        zip = $('#bh-sl-address').val(); 
        udate_deatbase(zip);
        //udate_big_query(zip);
     });

     function udate_deatbase(zip){
       
       setTimeout(function(){
         result = parseInt($('.bh-sl-loc-list .list li').length);

         var mark = $('.bh-sl-loc-list .list li').attr('data-markerid');
          
         if(typeof mark === 'undefined' ){
           result = 'No Address Found';
          }else{
            result = result+' Address found on this Zipcode';
          }  

          if(!block_id){
             ip_address =null;
             Lat= null;
             Lng =null;
             address=null;
           }    
   
            
            result = result+' Address found on this Zipcode'; 
            var get_current_url = window.location.href;  
            var url = 'https://beeveeapps.co/cadence/index.php?zipcode='+zip+'&latitude='+Lat+'&longitude='+Lng+'&result='+result+'&address='+g_addresds+'&type='+type_url+'&url='+ encodeURIComponent(get_current_url);
          //  var url = 'http://35.235.108.255/index.php?zipcode='+zip+'&latitude='+Lat+'&longitude='+Lng+'&result='+result+'&address='+g_addresds+'&type=Searched';
           
             $.ajax({url: url, success: function(show){
                console.log(show);
              }}); 


              // google
              var url_g = 'https://zipcodedb.cadenceotc.com/index.php?zipcode='+zip+'&latitude='+Lat+'&longitude='+Lng+'&result='+result+'&address='+g_addresds+'&type='+type_url+'&url='+ encodeURIComponent(get_current_url);
             
              $.ajax({url: url_g, success: function(show){
                console.log(show);
              }}); 

           
       
             var date = new Date();
             $('.ggsf_zipcode').val(zip);
             $('.ggsf_ipaddress').val(ip_address);
             $('.ggsf_latitude').val(Lat);
             $('.ggsf_longitude').val(Lng);
             $('.ggsf_address').val(address);
             $('.ggsf_result').val(result); 
             $('.ggsf_date').val(date); 
             $('.ggsf_type').val(type_url);
              $('.ggsf_url').val(url);

          
          const scriptURL = 'https://script.google.com/macros/s/AKfycbxOtCfgNKFv9zh8f29-9iHq4buHh6vQ7ujZH7YVNiJjwnaQDNZwj4am_4mgCnHHtu8u/exec'
          const form = document.forms['contact-form']
           
            fetch(scriptURL, { method: 'POST', body: new FormData(form)})
            .then(response => console.log("Thank you! your form is submitted successfully." )) 
            .catch(error => console.error('Error!', error.message))
           
         
             /*
            var url = 'https://beeveeapps.co/cadence/index.php?zipcode='+zip+'&latitude='+Lat+'&longitude='+Lng+'&result='+result;
              $.ajax({url: url, success: function(show){
                console.log(show);
              }});  
               */
         
        }, 2100); 
       
     } 

          // save value big query
      function udate_big_query(zip){
       
       setTimeout(function(){
         result = parseInt($('.bh-sl-loc-list .list li').length);

         var mark = $('.bh-sl-loc-list .list li').attr('data-markerid');
         
         if(typeof mark === 'undefined' ){
           result = 'No Address Found';
         }else{
            result = result+' Address found on this Zipcode';
         }

         

         var date = new Date();
         $('.ggsf_zipcode').val(zip);
         $('.ggsf_ipaddress').val(ip_address);
         $('.ggsf_latitude').val(Lat);
         $('.ggsf_longitude').val(Lng);
         $('.ggsf_address').val(address);
         $('.ggsf_result').val(result); 
         $('.ggsf_date').val(date); 

       
          const scriptURL = 'https://script.google.com/macros/s/AKfycbxOtCfgNKFv9zh8f29-9iHq4buHh6vQ7ujZH7YVNiJjwnaQDNZwj4am_4mgCnHHtu8u/exec'
          const form = document.forms['contact-form']
           
            fetch(scriptURL, { method: 'POST', body: new FormData(form)})
            .then(response => console.log("Thank you! your form is submitted successfully." )) 
            .catch(error => console.error('Error!', error.message))
          
       }, 2100);
       
     }



     $('#bh-sl-address, .mpst__input').on('input', function() {
      $(this).val($(this).val().replace(/[^a-z0-9]/gi, ' '));
    });
	
  },
  page_scroll: function(){
     
    $('.reputon-amazon-reviews-widget[data-type="basic"]').on('click', function(event){ 
       $('html,body').animate({
        scrollTop: $('.reputon-amazon-reviews-widget[data-type="grid"]').offset().top
       }, 600); 
     });
    
     $('.mrthd_list li').on('click', function(event){
        var id = parseInt($(this).closest('.mrthd_list').data('id'));
        var eventItem  =$(this).index() + id;

       $('html,body').animate({
        scrollTop: $('.scroll_div[data-id="'+eventItem+'"]').offset().top - 110
       }, 600);
          
     });

    $('.mrthd_link').on('click', function(event){ 
      event.preventDefault();
      $('html,body').animate({
        scrollTop: $('.imgtxtimg_seciton').offset().top - 110
       }, 600);
    });

    $('.page_scroll').on('click', function(event){
       event.preventDefault();
       var url = $(this).attr('href');
       $('html,body').animate({
        scrollTop: $(url).offset().top - 130
       }, 600);
    });

    $('.rlt_btn').on('click', function(){
        var password = $('.password_txt').val();
        if(password == 'bbhtrdw2M&251t'){
            $('.result_login').hide();
            $('.result_box').show();
          cadence.setCookie('map',1,1);
        }else{
           $('.show_error').html('Please Try again');
        }
    });

    if(cadence.getCookie('map') == 1){
        $('.result_login').hide();
        $('.result_box').show();
    }

    
  },
  setCookie: function(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
  },
  getCookie: function(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    },
  eraseCookie: function(key) {
        var keyValue = getCookie(key);
        setCookie(key, keyValue, '-1');
    },
  calculator: function(){

     $( "#datepicker" ).datepicker({
        dateFormat: "mm/dd/yy"
    }); 
     
     
     $('.cydt_icon').on('click', function(){
       $('.cydt_icon_hover').slideToggle();
     });

     $('.cydt_value').on('click', function(){
       $('.cydt_lists').slideToggle();
       
     });

     $('.cydt_li').on('click', function(){
        $('.cydt_lists').slideToggle();
        var day = $(this).data('day');
        var text = $(this).html();
       $('.cydt_value').html(text);
       $('.cydt_value').attr('data-val', day);

       $('.cydt_li').removeClass('active');
       $(this).addClass('active');

       show_result();
     });

     $('.cydt_date_value').change(function(){
       show_result();
       var date = $(this).val();
         console.log(date);
       if(date == ''){
         $('.cydt_date_input').html('MM/DD/YYYY');
       }else{
          //date = getFormattedDate(date); 
         // $('.cydt_date_input').html(date);
       } 
     });

     $('.cydt_date_input').on('click', function(){
        $('cydt_date_value').trigger("change");
     });
      

     
     $('.cyshv_btn').on('click', function(e){
        e.preventDefault();
       // $('.cydt_show_value, .pdclt_details').slideToggle();
        $('.cydt_show_value').slideToggle();
     });

    function getFormattedDate(dateString) {
      const date = new Date(dateString);
      var year = date.getFullYear(); 
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month; 
      var day = date.getDate().toString();
      day = parseInt(day.length > 1 ? day : '0' + day); 
      if(day != 1){
      day += 1;
      if(day == 32){
        day = 31;
      }
      console.log(month);
      if(month == '04' || month == '06' || month == '09' || month == '11'){
        if(day == 31){
          day = 30;
        }
      }
       if(month == '02'){
          if(day == 29){
          day = 28;
        }
       }
      }
      return month + '/' + day + '/' + year;
      //console.log( month + '/' + day + '/' + year);
      
    }

     function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }
     
     function show_result(){

       const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

       var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
       
      
       var day = $('.cydt_value').attr('data-val');
       var dt = $('.cydt_date_value').val();
       var l_date = dt;
          
       if(typeof day !== 'undefined' && l_date != ''){
         
         
         day = parseInt(day) - 6 ; 
         var date  = addDays(dt, day); 
         var new_date =  days[date.getDay()]+', '+ monthNames[date.getMonth()] +' '+ date.getDate() + ', ' + date.getFullYear();
         $('.cyshv_date_val').html(new_date); 
         
         day +=2;
          date = addDays(dt, day);
          new_date =   days[date.getDay()]+', '+monthNames[date.getMonth()] +' ' + date.getDate() + ', '  + date.getFullYear();
          $('.cyshv_date_fixed_val').html(new_date); 
         
         // $('.cyshv_date_last_val').html(getFormattedDate(l_date)); 
         $('.cyshv_date_last_val').html($('.cydt_date_value').val());
         
         $('.cydt_show_value').slideToggle();
        // $('.cydt_show_value, .pdclt_details').slideToggle();
       }
       
     }
     
   },
  addtocart: function(){

       var p_url = '';
    $('.direct_checkout').on('click', function(e){
        e.preventDefault();
       p_url = $(this).attr('href');
       var that = $(this);
      if($(this).hasClass('active')){
        $('.pdusl_popup').show();
         addtocart_form(that, '0'); 
      }else{  
        addtocart_form(that, '/cart');
      }
        
    });
    $('.pdusl_close, .pdusl_bg, .pdusl_link_2').on('click', function(e){
      
      $('.pdusl_popup').hide();
      window.location.href = '/cart';
       // window.location.href = p_url;
      // $('[action="/cart/add"]').submit();
      
    });
    

     $('.url_addtocart').on('click', function(e){
       e.preventDefault();
        var href = $(this).attr('href');
        //window.location.href = href;

       
       // $('[action="/cart/add"]').submit();
      // addtocart_form(href);
      
       /*
       setTimeout(function(){
         window.location.href = href;
       }, 800);
        */
     });

    $('.pdusl_link_1').on('click', function(e){
       e.preventDefault();
       var that = $(this);
       addtocart_form(that, '/cart');
    });
     

     

     function addtocart_form(that , url){
        $.ajax({type: 'POST',
          url: '/cart/add.js',
          data: that.closest('[action="/cart/add"]').serialize(),
          dataType: 'json',
          success: function(result){
             console.log(result);
            if(url != '0'){
              window.location.href = url;
            } 
         }
        });
     }
    
  },
  quick_view: function(){

    
      var grid = $('.masonry_grid');  
      //creater_masonry();
      function creater_masonry(){
        grid.masonry('layout');
      }

    
    $('.qkv_btn').on('click', function(e){
        e.preventDefault();
       $('.qkvw_section').slideUp().removeClass('active');
       // grid.masonry('destroy');
        var id = $(this).data('id');
        $('.qkvw_section[data-id="'+id+'"]').slideToggle().toggleClass('active');

      var order = parseInt($(this).closest('.grid_list').data('no'));
      var carryNumber = 0; 
      var w_order = 4;
      if($(window).width() < 989){
         w_order =2; 
      }  
        order +=w_order;
        carryNumber = order % w_order;
        if(carryNumber == 0){
          order -=w_order;
        }
       
       order -=carryNumber;
       order +=1;
       
      $('.qkvw_section[data-id="'+id+'"]').css('order', `${order}`);

      // creater_masonry();

       setTimeout(function(){
          $('html, body').animate({
            scrollTop:  $('.qkvw_section[data-id="'+id+'"]').offset().top - 100
          }, 800);
      }, 250)
    

       
      /*
      setTimeout(function(){
        if($('.qkvw_section[data-id="'+id+'"]').hasClass('active')){ 
           var height = $('.qkvw_section[data-id="'+id+'"]').height();
            console.log(height);
           $('#ProductGridContainer').css('marginBottom', height);
         }else{
           $('#ProductGridContainer').removeAttr('style');
         }
      }, 370);
      */
       
        
    });
    $('.qkvw_close').on('click', function(){ 
        $(this).closest('.qkvw_section').slideToggle().removeClass('active');
        $('#ProductGridContainer').removeAttr('style');
      
      
          $('html, body').animate({
            scrollTop:  $('body').offset().top - 100
          }, 1200); 
      
    });
    
  },
  search: function(){


    
    // Function to filter and sort items
    function filterAndSortItems() {
        const selectedDate = $('.ssb_date').val();
        const sortBy = $('#SortBy').val();

        // Parse the selected date if available
        const filterDate = selectedDate ? new Date(selectedDate) : null;

        // Filter and sort items based on selected date and sorting order
        const filteredItems = $('.pdgc_section_item').filter(function() {
            const itemDate = new Date($(this).data('date'));
            // If a date is selected, filter items with dates on or after the selected date
            return !filterDate || itemDate >= filterDate;
        }).sort(function(a, b) {
            const dateA = new Date($(a).data('date'));
            const dateB = new Date($(b).data('date'));

            // Sort by "New" (latest first) or "Old" (earliest first)
            return sortBy === 'New' ? dateB - dateA : dateA - dateB;
        });

        // Append the sorted and filtered items back into the .item container
        $('.pdgc_section').html(filteredItems);
    }

    // Event listeners for sorting and filtering
    $('#SortBy').change(filterAndSortItems);
    $('.ssb_date').change(filterAndSortItems);

    // Initial load
    filterAndSortItems();
 

    
       /*
       $('#SortBy').change(function() {
        // Get selected option
        const sortBy = $(this).val();
        $('.pdgc_section').html(
            $('.pdgc_section_item').sort(function(a, b) {
                const dateA = new Date($(a).data('date'));
                const dateB = new Date($(b).data('date')); 
                if (sortBy === 'New') {
                    return dateB - dateA;  
                } else {
                    return dateA - dateB;  
                }
            })
        ); 
    }).trigger('change');
    */

    
    /*
      $('.facet-filters__sort_custome').on('change', function(){
          var id = $(this).val(); 
      });
    */
    
  },
  allready_subscribe: function(){
      const urlParams = new URLSearchParams(window.location.search);
      const formType = urlParams.get('form_type');
      const tags = urlParams.get('contact%5Btags%5D');
  
      if (formType === 'customer') {
          // Display the appropriate message
          const $message = $('#subscribe-message');
          $message.text("You are already subscribed!");
          $message.css({ display: 'block', color: 'red' });
  
          // Optionally scroll to the message
          $('html, body').animate({
              scrollTop: $message.offset().top
          }, 500);
      }
  },
  thanks_page: function(){
    /*
    $('.tkln_btn').on('click', function(){
        var id = $(this).data('id');
        var width = parseInt($('.tkln_location').attr('data-width'));
       console.log(id);
        if(id == '1'){
          width = width - 10;
        }else{
          width = width + 10;
        }
        console.log(width);
         if(width < 0){
           width = 0;
         }
        if(width > 80){
           width =80;
         }
          $('.tkln_location').attr('data-width', width);
          $('.tkln_location').css('width', width+'%');
      
    });
    */

    $('.tkstpp_close').on('click', function(){
        $('.tkstpp_share').hide();
    });
    $('.tkst_show_pop').on('click', function(){
        var id = $(this).data('id');
        $('.tkstpp_share').hide();
        $('.tkstpp_share[data-id="'+id+'"]').show();
    }); 
  },
  ada_reveiw: function(){
    setTimeout(function(){
      $('.reputon-amazon-reviews-widget [data-content="Load more"]').html('LOAD MORE');
    }, 2500); 
    setTimeout(function(){
      $('.reputon-amazon-reviews-widget [data-content="Load more"]').html('LOAD MORE');
    }, 4500); 
    setTimeout(function(){
      $('.reputon-amazon-reviews-widget [data-content="Load more"]').html('LOAD MORE');
    }, 6500); 
    setTimeout(function(){
      $('.reputon-amazon-reviews-widget [data-content="Load more"]').html('LOAD MORE');
    }, 8500); 
  }
}

$(function(){
  cadence.slider();
  cadence.all_option();
  cadence.page_scroll();
  cadence.map();
  cadence.calculator();
  cadence.addtocart();
  cadence.quick_view();
  cadence.search();
  cadence.allready_subscribe();
  cadence.thanks_page();
  cadence.ada_reveiw();
});


$(window).scroll(function(){
  
  if($('.hmvd_section').length){
     var banner_height = $('.hmvd_section').height(); 
     if($(window).scrollTop() > banner_height){
       $('.mobile_addon_header').addClass('active');
     }else{
       $('.mobile_addon_header').removeClass('active');
     }
  }
   
})
